import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

export function AtlasPageDivider({ className = "mx-6" }) {
  return <div className={`h-[1px] bg-[#a15d33] ${className}`} aria-hidden="true" />;
}

export default function AtlasPageHeader({
  title,
  breadcrumb,
  showBack = true,
  subtitle,
  right,
  className = "",
}) {
  const navigate = useNavigate();

  return (
    <header
      className={`flex items-center justify-between ml-2 md:ml-6 mb-4 ${className}`}
    >
      <div
        className={`items-center gap-2 flex ${
          showBack ? "hidden md:flex" : ""
        }`}
      >
        {showBack ? (
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="p-2 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Go back"
          >
            <FaArrowLeft className="text-gray-700 text-lg" />
          </button>
        ) : null}
        <div>
          {breadcrumb ? (
            <p className="text-sm text-foreground">{breadcrumb}</p>
          ) : null}
          <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
          {subtitle ? (
            <p className="text-sm text-muted-foreground">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {right ? (
        <div className="flex shrink-0 items-center gap-2">{right}</div>
      ) : null}
    </header>
  );
}
